<template>
  <div>
    <div>
      <ResourceFilterModal
        ref="resourceFilterModal"
        :handleAnswer="handleAnswer"
        :disable_filter="disable_filter"
        :answer="filterType"
      />
      <ResourcesMobileFilterModal
        ref="resourceMobileFilterModal"
        :handleAnswer="handleAnswer"
        :disable_filter="disable_filter"
        :answer="filterType"
      />
      <div class="shadow-card mobile-top">
        <h3
          :style="{
            display: 'flex',
            'margin-top': '0px',
            'margin-bottom': '24px',
            'font-size': '32px',
            'font-weight': '700',
            color: '#0F1734'
          }"
        >
          Resources
        </h3>
        <div class="search-container">
          <div class="top-input-container">
            <font-awesome-icon
              :icon="['fal', 'search']"
              :style="{ color: getPrimaryColor(), width: '20px' }"
              class="cp ml-3 search-icon"
              @click="handleSubmit"
            />
            <a-input
              type="search"
              class="search-field"
              placeholder="Search by name"
              :value="searchKey"
              @change="handleSearch"
              @input="callDebounce"
              @keyup.enter="handleSubmit"
            >
            </a-input>
            <a-icon
              v-if="searchKey"
              class="close-icon mr-3 cp"
              style="width: fit-content;"
              type="close"
              :size="'large'"
              @click="handleClearSearch"
            />
          </div>
          <button
            @click="$refs.resourceFilterModal.show()"
            class="search-button show-button position-relative"
          >
            <img
              src="../../../assets/images/filter_icon.svg"
              alt="filter"
              height="14px"
              width="18px"
            /><span class="filter-text">Apply Filters</span>
            <div
              v-if="filterType != ''"
              class="active-filter-indicator"
              :style="{ background: getPrimaryColor() }"
            />
          </button>
          <button
            @click="$refs.resourceMobileFilterModal.show()"
            class="search-button show-button-mobile position-relative"
          >
            <img
              src="../../../assets/images/filter_icon.svg"
              alt="filter"
              height="14px"
              width="18px"
            /><span class="filter-text">Apply Filters</span>
            <div
              v-if="filterType != ''"
              class="active-filter-indicator"
              :style="{ background: getPrimaryColor() }"
            />
          </button>
        </div>
        <div v-if="filterType != ''" class="top_filters">
          <div style="display:flex; gap: 10px; align-items: center;">
            <div class="appliedFilter">Applied Filter:</div>
            <div class="filterTypeBox">
              <div class="filterTypeText">{{ filterTypeText }}</div>
              <i
                class="fa fa-times"
                aria-hidden="true"
                style="cursor: pointer"
                @click="() => handleAnswer('')"
              ></i>
            </div>
          </div>
          <div
            class="clear-filter"
            :style="{ color: getPrimaryColor() }"
            @click="() => handleAnswer('')"
          >
            Clear Filters
          </div>
        </div>
      </div>
      <div class="mobile-padding">
        <div v-if="loading" class="d-flex justify-content-center mt-3">
          <div>
            <div class="spinner-border position-absolute spinner-class"></div>
          </div>
          <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
            Loading...
          </div>
        </div>
        <div v-if="!loading">
          <div
            class="top-count-container  sort-dropdown"
            v-bind:style="[
              resourceData.data.length != 0 && !loading && filterType != ''
                ? { flexDirection: 'row' }
                : null
            ]"
          >
            <p
              class="resource-quantity-text hide-count"
              v-if="
                resourceData.data.length != 0 && !loading && filterType === ''
              "
            >
              Browse all resources ({{
                Object.keys(resourceData.main_article).length != 0 &&
                showMainArticle
                  ? parseInt(resourceData.paginator.total_count) + 1
                  : resourceData.paginator.total_count
              }})
            </p>
            <p
              class="resource-quantity-text show-count"
              v-if="
                resourceData.data.length != 0 && !loading && filterType === ''
              "
            >
              Browse all resources
            </p>
            <div
              v-if="
                resourceData.data.length != 0 && !loading && filterType === ''
              "
              class="mobile-top-count"
            >
              <p class="resource-quantity-text show-count">
                ({{
                  Object.keys(resourceData.main_article).length != 0 &&
                  showMainArticle
                    ? parseInt(resourceData.paginator.total_count) + 1
                    : resourceData.paginator.total_count
                }})
              </p>
              <a-dropdown
                v-if="resourceData.data.length != 0 && !loading"
                style="margin-top:7px"
                :trigger="['click']"
                :getPopupContainer="trigger => trigger.parentNode"
              >
                <p class="sort-text">
                  Show
                  <span style="font-weight: 700;">{{
                    sortKey === "atoz" ? "A-Z" : "Most recent"
                  }}</span>
                  <font-awesome-icon
                    size="lg"
                    style="margin-left: 8px;"
                    :icon="['fas', 'angle-down']"
                  />
                </p>
                <template #overlay>
                  <a-menu @click="e => sortList(e.key)">
                    <a-menu-item key="">Most recent</a-menu-item>
                    <a-menu-item key="atoz">A-Z</a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
            <p
              class="resource-quantity-text"
              v-if="
                resourceData.data.length != 0 && !loading && filterType != ''
              "
            >
              {{
                showMainArticle
                  ? parseInt(resourceData.paginator.total_count) + 1
                  : resourceData.paginator.total_count
              }}
              Results
            </p>
            <a-dropdown
              v-if="resourceData.data.length != 0 && !loading"
              :trigger="['click']"
              :getPopupContainer="trigger => trigger.parentNode"
              class="sort-drop"
              v-bind:style="[
                resourceData.data.length != 0 && !loading && filterType != ''
                  ? { display: 'block' }
                  : null
              ]"
              style="margin-top:7px"
            >
              <p class="sort-text">
                Show
                <span style="font-weight: 700;">{{
                  sortKey === "atoz" ? "A-Z" : "Most recent"
                }}</span>
                <font-awesome-icon
                  size="lg"
                  style="margin-left: 8px;"
                  :icon="['fas', 'angle-down']"
                />
              </p>
              <template #overlay>
                <a-menu @click="e => sortList(e.key)">
                  <a-menu-item key="">Most recent</a-menu-item>
                  <a-menu-item key="atoz">A-Z</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
          <ArticleCard
            v-if="
              Object.keys(resourceData.main_article).length != 0 &&
                currentPage === 1 &&
                showMainArticle
            "
            :articleData="resourceData.main_article"
          />
          <div
            v-if="
              resourceData.data.length === 0 &&
                !loading &&
                Object.keys(resourceData.main_article).length != 0
            "
            :style="{ textAlign: 'center' }"
          >
            <p v-if="searchKey != '' || filterType != ''">No Resource found</p>
          </div>
          <div
            v-if="
              resourceData.data.length === 0 &&
                Object.keys(resourceData.main_article).length === 0 &&
                !loading
            "
            :style="{ textAlign: 'center' }"
          >
            No Resource found
          </div>
          <div v-for="card in resourceData.data" :key="card.id">
            <ArticleCard v-if="card.type === 'articles'" :articleData="card" />
            <PollCard v-if="card.type === 'poll'" :pollData="card.poll" />
            <SlideshowCard
              v-if="card.type === 'slideshows'"
              :videoData="card"
            />
            <TriviaCard v-if="card.type === 'trivia'" :pollData="card.trivia" />
            <VideoCard v-if="card.type === 'videos'" :videoData="card" />
          </div>
          <div
            v-if="resourceData.data.length != 0"
            :style="{
              padding: '30px',
              display: 'flex',
              justifyContent: 'center'
            }"
          >
            <a-pagination
              v-model="currentPage"
              class="dovemed-custom-pagination"
              :total="
                resourceData.paginator.total_count
                  ? Number(resourceData.paginator.total_count)
                  : 0
              "
              show-less-items
              :pageSize="10"
              @change="fetchNextPage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import ArticleCard from "./previews/ArticleCard";
import VideoCard from "./previews/VideoCard";
import SlideshowCard from "./previews/SlideshowCard";
import PollCard from "./previews/PollCard";
import TriviaCard from "./previews/TriviaCard";
import QuizCard from "./previews/QuizCard";
import { Input } from "ant-design-vue";
import ResourceFilterModal from "../../Modals/ResourceFilterModal.vue";
import ResourcesMobileFilterModal from "../../Modals/ResourcesMobileFilterModal.vue";

const ResourceRepository = RepositoryFactory.get("resource");

export default {
  name: "ResourceList",
  data() {
    return {
      showMainArticle: true,
      currentPage: 1,
      resourceData: [],
      page: 1,
      loading: false,
      filterType: "",
      searchKey: "",
      sortKey: "",
      filterTypeText: "",
      disable_filter: [true, true, true, true, true, true, true, true, true]
    };
  },
  components: {
    ResourceFilterModal,
    ArticleCard,
    VideoCard,
    SlideshowCard,
    PollCard,
    QuizCard,
    TriviaCard,
    "a-input": Input,
    ResourcesMobileFilterModal
  },

  created() {
    this.setVariablesFromQuery();
    this.$route.query.currentPage = 1;
    this.fetchResources();
  },

  watch: {
    "$route.query.currentPage": {
      handler() {
        if (this.$route.query.currentPage === undefined) {
          this.currentPage = 1;
          this.searchKey = "";
          this.sortKey = "";
          this.filterType = "";
          this.filterTypeText = "";
          this.fetchNextPage();
        }
      }
    },
    filterType: {
      handler() {
        this.handlePathQuery("filterType");
      }
    },
    sortKey: {
      handler() {
        this.handlePathQuery("sortKey");
      }
    },
    currentPage: {
      handler() {
        this.handlePathQuery("currentPage");
      }
    }
  },

  methods: {
    setVariablesFromQuery() {
      Object.keys(this.$route.query).forEach(key => {
        if (this.$route.query[key]) {
          this[key] = this.$route.query[key];
        }
      });
      if (this.$route.query.filterType) {
        this.filterTypeTextFn(this.$route.query.filterType);
      }
    },
    handlePathQuery(v) {
      this.$router
        .replace({
          ...this.$route,
          query: {
            ...this.$route.query,
            [v]: this[v]
          }
        })
        .catch(e => {});
    },
    sortList(sort) {
      this.sortKey = sort;
      this.fetchNextPage();
    },
    handleSearch(e) {
      this.searchKey = e.target.value;
    },
    handleClearSearch(){
      this.searchKey = "";
      this.handleSubmit();
    },
    handleSubmit() {
      this.currentPage = 1;
      this.fetchNextPage();
    },
    callDebounce: _.debounce(function() {
      this.handleSubmit();
    }, 500),
    handleAnswer(ans = "") {
      this.filterType = ans;
      this.currentPage = 1;
      this.filterTypeTextFn(ans);
      this.fetchNextPage();
    },
    filterTypeTextFn(filterType) {
      switch (filterType) {
        case "articles":
          this.filterTypeText = "Articles";
          break;
        case "poll":
          this.filterTypeText = "Polls";
          break;
        case "quiz":
          this.filterTypeText = "Quizzes";
          break;
        case "trivia":
          this.filterTypeText = "Trivia";
          break;
        case "slideshows":
          this.filterTypeText = "Slideshows";
          break;
        case "videos":
          this.filterTypeText = "Videos";
          break;
        case "physicianBlogs":
          this.filterTypeText = "Physician Blogs";
          break;
        case "askADoctor":
          this.filterTypeText = "Ask A Doctor";
          break;
        case "recommended":
          this.filterTypeText = "Recommended";
          break;
      }
    },
    fetchResources() {
      this.loading = true;
      this.handlePathQuery("searchKey");
      ResourceRepository.getResourceList(
        this.currentPage,
        10,
        this.currentCircle.id,
        this.filterType,
        this.searchKey,
        this.sortKey
      )
        .then(res => {
          if (
            this.currentPage === 1 &&
            this.searchKey === "" &&
            (this.filterType === "" || this.filterType === "articles")
          ) {
            this.showMainArticle = true;
          } else {
            this.showMainArticle = false;
          }
          this.loading = false;
          this.resourceData = res.data;
          this.setDisableFilter();
        })
        .catch(err => {
          this.loading = false;
        });
    },

    setDisableFilter() {
      if (this.resourceData.data.length != 0) {
        this.disable_filter[0] = !this.resourceData.data_exists.articles;
        this.disable_filter[1] = !this.resourceData.data_exists.poll;
        this.disable_filter[3] = !this.resourceData.data_exists.trivia;
        this.disable_filter[4] = !this.resourceData.data_exists.slideshows;
        this.disable_filter[5] = !this.resourceData.data_exists.videos;
      }
    },

    fetchNextPage() {
      this.loading = true;
      this.handlePathQuery("searchKey");
      document.body.scrollTop = 0;
      ResourceRepository.getResourceList(
        this.currentPage,
        10,
        this.currentCircle.id,
        this.filterType,
        this.searchKey,
        this.sortKey
      )
        .then(res => {
          this.resourceData = res.data;
          if (
            this.currentPage === 1 &&
            this.searchKey === "" &&
            (this.filterType === "" || this.filterType === "articles")
          ) {
            this.showMainArticle = true;
          } else {
            this.showMainArticle = false;
          }
          this.loading = false;
        })
        .catch(err => {
          if (
            this.currentPage === 1 &&
            this.searchKey === "" &&
            (this.filterType === "" || this.filterType === "articles")
          ) {
            this.showMainArticle = true;
          } else {
            this.showMainArticle = false;
          }
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important ;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>

<style lang="scss" scoped>
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
  /* color: #FFFFFF; */
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff;
}

.mobile-top {
  @media only screen and (max-width: 700px) {
    -webkit-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    padding: 24px 24px;
  }
}
.top-count-container {
  margin-top: 48px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 700px) {
    margin-top: 24px;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }
}
.resource-quantity-text {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #0f1734;
  margin-bottom: 0px;
}
.mobile-top-count {
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media only screen and (min-width: 701px) {
    display: none;
  }
}
.show-count {
  @media only screen and (min-width: 701px) {
    display: none;
  }
}
.hide-count {
  @media only screen and (max-width: 700px) {
    display: none;
  }
}

.sort-drop {
  @media only screen and (max-width: 700px) {
    display: none;
  }
}

.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: pointer;
}

.search-container {
  @media screen and (min-width: 701px) {
    display: flex;
  }
}

.top-input-container {
  display: flex;
  background: #f1f5f9;
  border-radius: 8px;
  margin-right: 24px;
  height: 60px;
  width: 100%;
  align-items: center;
  .search-icon {
    @media only screen and (min-width: 701px) {
      display: none;
    }
  }
}
.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
  height: 60px;
  width: 100%;
}

.show-button {
  @media screen and (max-width: 700px) {
    display: none;
  }
}
.show-button-mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (min-width: 701px) {
    display: none;
  }
}
.active-filter-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  align-self: flex-start;
  margin-top: 18px;
  margin-left: 5px;
  @media screen and (min-width: 701px) {
    top: 0;
    right: 0;
    position: absolute;
    margin-right: 10px;
    margin-top: 15px;
  }
}

.search-button {
  width: 60px;
  height: 60px;
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  @media screen and (max-width: 700px) {
    width: 100%;
    margin-top: 16px;
  }
  .filter-text {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    color: #0f1734;
    margin-left: 16px;
    @media screen and (min-width: 701px) {
      display: none;
    }
  }
}

.clear-filter {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  @media screen and (max-width: 700px) {
    margin-top: 16px;
    align-self: center;
  }
}

.mobile-padding {
  @media screen and (max-width: 700px) {
    padding: 0px 16px;
  }
}
.top_filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  @media screen and (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
}
.appliedFilter {
  font-weight: 700;
  font-size: 14px;
  color: #647490;
  line-height: 24px;
  @media only screen and (max-width: 700px) {
    display: none;
  }
}

.filterTypeBox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 8px;
  background: #f1f5f9;
  border-radius: 6px;

  .filterTypeText {
    font-weight: 700;
    font-size: 14px;
    color: #0f1734;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/resources/ResourceList.vue